import portalSlice from './store';
import { configureStore  } from '@reduxjs/toolkit'

export const store = configureStore({
    reducer: portalSlice.reducer
});


